import { APP_CONSTANTS } from 'packages/frontend/src/constants/app.constants';
import { Feature } from './types';

interface FeaturesGridProps {
  features: Feature[];
}

export function FeaturesGrid({ features }: FeaturesGridProps) {
  return (
    <div className="px-3 xs:px-4 sm:px-6 md:px-8 py-8 xs:py-10 sm:py-12 md:py-16 lg:py-20 bg-white mx-2 sm:mx-4 lg:mx-8">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-8 xs:mb-10 sm:mb-12 md:mb-16">
          {/* Main Title */}
          <h2 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold text-[#1D2125] mb-3 xs:mb-4">
            What you run in {APP_CONSTANTS.APP_NAME}
          </h2>
        </div>

        {/* Features Grid - Responsive columns */}
        <div className="grid grid-cols-1 xs:grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            const isLastInRowSm = (index + 1) % 2 === 0;
            const isLastInRowLg = (index + 1) % 3 === 0;
            const isLastInRowXl = (index + 1) % 4 === 0;
            const lastRowStartSm = Math.floor((features.length - 1) / 2) * 2;
            const lastRowStartLg = Math.floor((features.length - 1) / 3) * 3;
            const lastRowStartXl = Math.floor((features.length - 1) / 4) * 4;
            const isInLastRowSm = index >= lastRowStartSm;
            const isInLastRowLg = index >= lastRowStartLg;
            const isInLastRowXl = index >= lastRowStartXl;
            
            return (
              <div
                key={index}
                className={`
                  bg-white p-4 xs:p-5 sm:p-6 md:p-8 text-left
                  border-b border-gray-200
                  sm:border-r sm:border-gray-200 
                  lg:border-r lg:border-gray-200
                  xl:border-r xl:border-gray-200
                  ${isLastInRowSm ? 'sm:border-r-0' : ''}
                  ${isLastInRowLg ? 'lg:border-r-0' : ''}
                  ${isLastInRowXl ? 'xl:border-r-0' : ''}
                  ${isInLastRowSm ? 'sm:border-b-0' : ''}
                  ${isInLastRowLg ? 'lg:border-b-0' : ''}
                  ${isInLastRowXl ? 'xl:border-b-0' : ''}
                  ${index === features.length - 1 ? 'border-b-0' : ''}
                `}
              >
                {/* Icon and Content */}
                <div className="flex items-start gap-3 xs:gap-4">
                  <div className="w-8 xs:w-9 sm:w-10 h-8 xs:h-9 sm:h-10 flex items-center justify-center flex-shrink-0">
                    <IconComponent className="h-5 xs:h-5.5 sm:h-6 w-5 xs:w-5.5 sm:w-6 text-[#1D2125]" strokeWidth={2} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-base xs:text-lg sm:text-xl font-bold text-[#1D2125] mb-1.5 xs:mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-sm xs:text-sm sm:text-base text-[#4D4F52] leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

